var _rect, _line, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "This is a calendar icon that indicates you are in a date picker form input") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2,
    width: 14,
    height: 13,
    rx: 1,
    stroke: "#73777C",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 6,
    x2: 15,
    y2: 6,
    stroke: "#73777C",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 8.5,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "#2D2D2D",
    stroke: "#73777C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 8.5,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "#2D2D2D",
    stroke: "#73777C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 8.5,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "#2D2D2D",
    stroke: "#73777C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 11.5,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "#2D2D2D",
    stroke: "#73777C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 11.5,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "#2D2D2D",
    stroke: "#73777C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 11.5,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "#2D2D2D",
    stroke: "#73777C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 0.5,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#2D2D2D",
    stroke: "#73777C"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 0.5,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#2D2D2D",
    stroke: "#73777C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f9b8f7bd8177a2befa77aa3d57def64b.svg";
export { ForwardRef as ReactComponent };